<template>
  <tmp-boundary-login>
    <h1>境界立会申請フォーム</h1>
    <jr-boundary-step :active="step" />
    <template v-if="isInputMode || isConfirmMode">
      <div style="padding: 10px">
        <jr-regist-confirm-message v-if="isConfirmMode" />
        <div v-else class="required_message">(<span class="required-mark">*</span>)は必須です。</div>
      </div>

      <el-form :model="form" :rules="rules" ref="formRef">
        <input-group title="申請者" class="my">
          <!-- 事業者名(法人の場合) -->
          <el-row class="input-row row-height">
            <el-col :span="5">
              <input-label :required="false"> 法人名(法人の場合) </input-label>
            </el-col>
            <el-col :span="19">
              <el-form-item prop="request_header.applicant_business_name" class="applicant_business_name">
                <jr-text v-model="form.request_header.applicant_business_name" :isEdit="isInputMode" />
              </el-form-item>
            </el-col>
          </el-row>
          <!-- 担当者氏名 -->
          <el-row class="input-row row-height">
            <el-col :span="5">
              <input-label :required="true"> 氏名 </input-label>
            </el-col>
            <el-col :span="19">
              <el-form-item prop="request_header.applicant_manager_name" class="applicant_manager_name">
                <jr-text v-model="form.request_header.applicant_manager_name" :isEdit="isInputMode" />
              </el-form-item>
            </el-col>
          </el-row>
          <!-- 住所 -->
          <el-row class="input-row row-height">
            <el-col :span="5">
              <input-label :required="true"> 住所 </input-label>
            </el-col>
            <el-col :span="19">
              <el-form-item prop="request_header.applicant_address" class="applicant_address">
                <jr-text v-model="form.request_header.applicant_address" :isEdit="isInputMode" />
              </el-form-item>
            </el-col>
          </el-row>
          <!-- 申請者電話番号 -->
          <el-row class="input-row row-height">
            <el-col :span="5">
              <input-label :required="true"> 電話番号 </input-label>
            </el-col>
            <el-col :span="19">
              <el-form-item prop="request_header.applicant_tel" class="applicant_tel">
                <jr-text v-model="form.request_header.applicant_tel" :isEdit="isInputMode" placeholder="000-000-0000" />
              </el-form-item>
            </el-col>
          </el-row>
        </input-group>

        <input-group title="代理人" class="my">
          <!-- 事業者名(法人の場合) -->
          <el-row class="input-row row-height">
            <el-col :span="5">
              <input-label :required="false"> 法人名(法人の場合) </input-label>
            </el-col>
            <el-col :span="19">
              <el-form-item prop="agent_corporate_name" class="agent_corporate_name">
                <jr-text v-model="form.agent_corporate_name" :isEdit="isInputMode" />
              </el-form-item>
            </el-col>
          </el-row>
          <!-- 担当者氏名 -->
          <el-row class="input-row row-height">
            <el-col :span="5">
              <input-label :required="false"> 氏名 </input-label>
            </el-col>
            <el-col :span="19">
              <el-form-item prop="agent_name" class="agent_name">
                <jr-text v-model="form.agent_name" :isEdit="isInputMode" />
              </el-form-item>
            </el-col>
          </el-row>
          <!-- 住所 -->
          <el-row class="input-row row-height">
            <el-col :span="5">
              <input-label :required="false"> 住所 </input-label>
            </el-col>
            <el-col :span="19">
              <el-form-item prop="agent_address" class="agent_address">
                <jr-text v-model="form.agent_address" :isEdit="isInputMode" />
              </el-form-item>
            </el-col>
          </el-row>
        </input-group>

        <input-group title="連絡先（立会に来られる方）" class="my">
          <!-- 連絡先電話番号 -->
          <el-row class="input-row row-height">
            <el-col :span="5">
              <input-label :required="true"> 連絡先電話番号 </input-label>
            </el-col>
            <el-col :span="19">
              <el-form-item prop="contact_tel" class="contact_tel">
                <jr-text v-model="form.contact_tel" :isEdit="isInputMode" placeholder="000-000-0000" />
              </el-form-item>
            </el-col>
          </el-row>
        </input-group>

        <input-group title="申請内容" class="my">
          <!-- 申請目的 -->
          <el-row class="input-row row-height">
            <el-col :span="5">
              <input-label :required="true"> 申請目的 </input-label>
            </el-col>
            <el-col :span="6">
              <el-form-item prop="request_reason_type" class="request_reason_type">
                <request-reason-type-select :isEdit="isInputMode" v-model="form.request_reason_type" />
              </el-form-item>
            </el-col>
            <el-col :span="6" :offset="1">
              <input-label> (その他の場合記入) </input-label>
            </el-col>
            <el-col :span="6">
              <form-item-disabled
                prop="request_reason_type_other"
                class="request_reason_type_other"
                :disabled="form.request_reason_type !== RequestReasonTypes.OTHER.code"
              >
                <jr-text
                  v-if="isInputMode || form.request_reason_type === RequestReasonTypes.OTHER.code"
                  v-model="form.request_reason_type_other"
                  :isEdit="isInputMode"
                  :disabled="form.request_reason_type !== RequestReasonTypes.OTHER.code"
                />
                <jr-input-view v-else class="empty"></jr-input-view>
              </form-item-disabled>
            </el-col>
          </el-row>
          <!-- 作業内容 -->
          <el-row class="input-row row-height">
            <el-col :span="5">
              <input-label> 作業内容 </input-label>
            </el-col>
            <el-col :span="6">
              <el-form-item prop="work_content_count" class="work_content_count">
                <jr-checkbox
                  :isEdit="isInputMode"
                  v-if="isInputMode || form.is_boundary_marker_confirm"
                  v-model="form.is_boundary_marker_confirm"
                  class="is_boundary_marker_confirm"
                >
                  境界標確認
                </jr-checkbox>
                <jr-checkbox
                  :isEdit="isInputMode"
                  v-if="isInputMode || form.is_boundary_marker_restore"
                  v-model="form.is_boundary_marker_restore"
                  class="is_boundary_marker_restore"
                >
                  境界標復元
                </jr-checkbox>
                <jr-checkbox
                  :isEdit="isInputMode"
                  v-if="isInputMode || form.is_boundary_fixed_surveying"
                  v-model="form.is_boundary_fixed_surveying"
                  class="is_boundary_fixed_surveying"
                >
                  境界確定測量
                </jr-checkbox>
              </el-form-item>
            </el-col>
          </el-row>
        </input-group>

        <input-group title="申請地" class="my">
          <!-- 所在 -->
          <el-row class="input-row row-height">
            <el-col :span="5">
              <input-label :required="true"> 所在 </input-label>
            </el-col>
            <el-col :span="14">
              <el-form-item prop="location" class="location">
                <jr-text v-model="form.location" :isEdit="isInputMode" />
              </el-form-item>
            </el-col>
            <el-col :span="5" style="padding-left: 4px">
              <jr-geocoder
                :address="form.location"
                :disabled="isConfirmMode"
                v-model:lat="mapCenterLat"
                v-model:lng="mapCenterLng"
                @change="changeMapCenter"
              >
                住所から地図を表示
              </jr-geocoder>
            </el-col>
          </el-row>
          <!-- 地番 -->
          <el-row class="input-row row-height">
            <el-col :span="5">
              <input-label :required="true"> 地番 </input-label>
            </el-col>
            <el-col :span="4">
              <el-form-item prop="parcel_number" class="parcel_number">
                <jr-text v-model="form.parcel_number" :isEdit="isInputMode" />
              </el-form-item>
            </el-col>
            <!-- 地目 -->
            <el-col :span="2" :offset="1">
              <input-label :required="true"> 地目 </input-label>
            </el-col>
            <el-col :span="4">
              <el-form-item prop="land_category" class="land_category">
                <jr-text v-model="form.land_category" :isEdit="isInputMode" />
              </el-form-item>
            </el-col>
            <!-- 地積 -->
            <el-col :span="2" :offset="1">
              <input-label :required="true"> 地積 </input-label>
            </el-col>
            <el-col :span="5">
              <el-form-item prop="parcel_area" class="parcel_area">
                <jr-number
                  v-model="form.parcel_area"
                  :isEdit="isInputMode"
                  :isString="true"
                  :min="0"
                  :step="0.01"
                  :autoDecimalOfBlur="2"
                >
                  <template #suffix>m<sup>2</sup></template>
                </jr-number>
              </el-form-item>
            </el-col>
          </el-row>
          <!-- 路線・駅間 -->
          <el-row class="input-row row-height">
            <el-col :span="5">
              <input-label :required="false"> 路線 </input-label>
            </el-col>
            <el-col :span="6">
              <el-form-item prop="line" class="line">
                <Suspense>
                  <line-select
                    v-model="form.line"
                    @update:name="form.line_name = $event"
                    :isEdit="isInputMode"
                    :nullable="true"
                  />
                </Suspense>
              </el-form-item>
            </el-col>
            <el-col :span="2" :offset="1">
              <input-label :required="false"> 駅間 </input-label>
            </el-col>
            <el-col :span="4">
              <el-form-item prop="start_station" class="start_station" :error="validationError.start_station">
                <Suspense>
                  <station-select
                    v-model="form.start_station"
                    :lineCode="form.line"
                    :isEdit="isInputMode"
                    :filterByLine="true"
                    :nullable="true"
                    @update:name="form.start_station_name = $event"
                  />
                </Suspense>
              </el-form-item>
            </el-col>
            <el-col :span="1">
              <span class="mx-2">～</span>
            </el-col>
            <el-col :span="4">
              <el-form-item prop="end_station" class="end_station" :error="validationError.end_station">
                <Suspense>
                  <station-select
                    v-model="form.end_station"
                    :lineCode="form.line"
                    :isEdit="isInputMode"
                    :filterByLine="true"
                    :nullable="true"
                    @update:name="form.end_station_name = $event"
                  />
                </Suspense>
              </el-form-item>
            </el-col>
          </el-row>
          <!-- 申請地座標 -->
          <el-row>
            <el-col :span="12">
              <input-label :required="true"> 申請地 </input-label>
              <span>(地図上でクリックしてください。)</span><br />
              <span class="text-xs pl-1">マウスホイール（またはピンチ）により拡大・縮小できます。</span>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="24">
              <el-form-item prop="latitude" class="latitude">
                <jr-map
                  v-model:lat="form.latitude"
                  v-model:lng="form.longitude"
                  v-model:centerLat="mapCenterLat"
                  v-model:centerLng="mapCenterLng"
                  :zoom="mapZoom"
                  :isEdit="isInputMode"
                  style="width: 100%; height: 600px"
                />
              </el-form-item>
            </el-col>
          </el-row>
        </input-group>

        <input-group title="JR用地情報" class="my">
          <!-- 所在 -->
          <el-row class="input-row row-height">
            <el-col :span="5">
              <input-label :required="false"> 所在 </input-label>
            </el-col>
            <el-col :span="19">
              <el-form-item prop="jr_site_location" class="jr_site_location">
                <jr-text v-model="form.jr_site_location" :isEdit="isInputMode" />
              </el-form-item>
            </el-col>
          </el-row>
          <!-- 地番 -->
          <el-row class="input-row row-height">
            <el-col :span="5">
              <input-label :required="false"> 地番 </input-label>
            </el-col>
            <el-col :span="6">
              <el-form-item prop="jr_site_parcel_number" class="jr_site_parcel_number">
                <jr-text v-model="form.jr_site_parcel_number" :isEdit="isInputMode" />
              </el-form-item>
            </el-col>
          </el-row>
        </input-group>

        <input-group title="添付書類" class="my">
          <el-row class="input-row">
            <el-col class="explanation-message font-sm" :span="24">
              ※添付書類は
              <a :href="sumpleSubmissionsUrl" class="sumple-submissions" target="_blank" rel="noopener noreferrer">
                記載例 </a
              >をご確認の上、作成をお願いいたします。
            </el-col>
          </el-row>
          <el-row class="input-row">
            <el-col class="explanation-message font-sm" :span="24"
              >※写真は、可能な限り線路と対象地が入るように、JR用地外から撮影したものを添付してください。
            </el-col>
          </el-row>
          <el-row class="input-row">
            <el-col class="explanation-message font-sm" :span="24">※線路内には絶対に入らないでください。 </el-col>
          </el-row>
          <el-row class="input-row">
            <el-col class="explanation-message caution-message font-sm" :span="24"
              >※現地測量を行う際は、必ずJR用地外の安全な場所で実施して下さい。<br />
              <span class="pl-4"
                >線路内への立入りや電気設備への接近は列車との接触や感電の危険性があり大変危険です。 </span
              ><br />
              <span class="pl-4">測量が困難な場合は概算距離（目測で可）を記載して下さい。</span>
            </el-col>
          </el-row>
          <el-row class="input-row">
            <el-col class="explanation-message font-sm" :span="24"
              >※形式はPDF,JPG,PNG,DOCX,DOC,XLSX,XLSで、1ファイル10Mまでとなります。
            </el-col>
          </el-row>
          <!-- 境界 -->
          <el-row class="top-input-row row-height">
            <el-col :span="8">
              <input-label :required="true"> 境界(確認・立会・明示)申請書 </input-label>
            </el-col>
            <el-col :span="16">
              <el-form-item prop="boundary_application_form_file_selected" class="boundary_application_form_file">
                <jr-file-input
                  ref="boundary_application_form_file_ref"
                  v-model="form.boundary_application_form_file"
                  :fileType="FileTypes.BOUNDARY_APPLICATION_FORM"
                  :allowExts="allowExts"
                  @update:selected="form.boundary_application_form_file_selected = $event"
                  :disabled="isConfirmMode"
                />
              </el-form-item>
            </el-col>
          </el-row>
          <!-- 本人確認写(免許書等) -->
          <el-row class="input-row">
            <el-col :span="8" class="identification-file-label">
              <input-label :required="false"
                ><el-col> 本人確認写(免許書等)</el-col><el-col>(立会に来られる方)</el-col></input-label
              >
            </el-col>
            <el-col :span="16">
              <el-form-item prop="identification_file_selected" class="identification_file">
                <jr-file-input
                  ref="identification_file_ref"
                  v-model="form.identification_file"
                  :fileType="FileTypes.BOUNDARY_IDENTIFICATION"
                  :allowExts="allowExts"
                  @update:selected="form.identification_file_selected = $event"
                  :disabled="isConfirmMode"
                />
              </el-form-item>
            </el-col>
          </el-row>
          <!-- 委任状 -->
          <el-row class="input-row row-height">
            <el-col :span="8">
              <input-label :required="false"> 委任状 </input-label>
            </el-col>
            <el-col :span="16">
              <el-form-item prop="power_of_attorney_file_selected" class="power_of_attorney_file">
                <jr-file-input
                  ref="power_of_attorney_file_ref"
                  v-model="form.power_of_attorney_file"
                  :fileType="FileTypes.BOUNDARY_POWER_OF_ATTORNEY"
                  :allowExts="allowExts"
                  @update:selected="form.power_of_attorney_file_selected = $event"
                  :disabled="isConfirmMode"
                />
              </el-form-item>
            </el-col>
          </el-row>
          <!-- 位置図 -->
          <el-row class="input-row row-height">
            <el-col :span="8">
              <input-label :required="true"> 位置図 </input-label>
            </el-col>
            <el-col :span="16">
              <el-form-item prop="location_map_file_selected" class="location_map_file">
                <jr-file-input
                  ref="location_map_file_ref"
                  v-model="form.location_map_file"
                  :fileType="FileTypes.BOUNDARY_LOCATION_MAP"
                  :allowExts="allowExts"
                  @update:selected="form.location_map_file_selected = $event"
                  :disabled="isConfirmMode"
                />
              </el-form-item>
            </el-col>
          </el-row>
          <!-- 平面図 -->
          <el-row class="input-row row-height">
            <el-col :span="8">
              <input-label :required="true"> 平面図 </input-label>
            </el-col>
            <el-col :span="16">
              <el-form-item prop="ground_plan_file_selected" class="ground_plan_file">
                <jr-file-input
                  ref="ground_plan_file_ref"
                  v-model="form.ground_plan_file"
                  :fileType="FileTypes.BOUNDARY_GROUND_PLAN"
                  :allowExts="allowExts"
                  @update:selected="form.ground_plan_file_selected = $event"
                  :disabled="isConfirmMode"
                />
              </el-form-item>
            </el-col>
          </el-row>
          <!-- 地積測量図 -->
          <el-row class="input-row row-height">
            <el-col :span="8">
              <input-label :required="false"> 地積測量図 </input-label>
            </el-col>
            <el-col :span="16">
              <el-form-item prop="survey_drawing_of_acreage_file_selected" class="survey_drawing_of_acreage_file">
                <jr-file-input
                  ref="survey_drawing_of_acreage_file_ref"
                  v-model="form.survey_drawing_of_acreage_file"
                  :fileType="FileTypes.BOUNDARY_SURVEY_DRAWING_OF_ACREAGE"
                  :allowExts="allowExts"
                  @update:selected="form.survey_drawing_of_acreage_file_selected = $event"
                  :disabled="isConfirmMode"
                />
              </el-form-item>
            </el-col>
          </el-row>
          <!-- 公図 -->
          <el-row class="input-row row-height">
            <el-col :span="8">
              <input-label :required="true"> 公図 </input-label>
            </el-col>
            <el-col :span="16">
              <el-form-item prop="cadastral_map_file_selected" class="cadastral_map_file">
                <jr-file-input
                  ref="cadastral_map_file_ref"
                  v-model="form.cadastral_map_file"
                  :fileType="FileTypes.BOUNDARY_CADASTRAL_MAP"
                  :allowExts="allowExts"
                  @update:selected="form.cadastral_map_file_selected = $event"
                  :disabled="isConfirmMode"
                />
              </el-form-item>
            </el-col>
          </el-row>
          <!-- 登記事項証明書 -->
          <el-row class="input-row row-height">
            <el-col :span="8">
              <input-label :required="true"> 登記事項証明書 </input-label>
            </el-col>
            <el-col :span="16">
              <el-form-item
                prop="certificate_of_registered_matters_file_selected"
                class="certificate_of_registered_matters_file"
              >
                <jr-file-input
                  ref="certificate_of_registered_matters_file_ref"
                  v-model="form.certificate_of_registered_matters_file"
                  :fileType="FileTypes.BOUNDARY_CERTIFICATE_OF_REGISTERED_MATTERS"
                  :allowExts="allowExts"
                  @update:selected="form.certificate_of_registered_matters_file_selected = $event"
                  :disabled="isConfirmMode"
                />
              </el-form-item>
            </el-col>
          </el-row>
          <!-- 現地写真 -->
          <el-row class="input-row row-height">
            <el-col :span="8">
              <input-label :required="false"> 現地写真 </input-label>
            </el-col>
            <el-col :span="16">
              <el-form-item prop="actual_place_photo_file_selected" class="actual_place_photo_file">
                <jr-file-input
                  ref="actual_place_photo_file_ref"
                  v-model="form.actual_place_photo_file"
                  :fileType="FileTypes.BOUNDARY_ACTUAL_PLACE_PHOTO"
                  :allowExts="allowExts"
                  @update:selected="form.actual_place_photo_file_selected = $event"
                  :disabled="isConfirmMode"
                />
              </el-form-item>
            </el-col>
          </el-row>
        </input-group>

        <el-row class="input-row my">
          <el-col :span="22" :offset="1">
            <personal-info />
          </el-col>
        </el-row>

        <el-row class="input-row my">
          <el-col :span="10" :offset="1" class="align-middle">
            <input-label :required="true"> 個人情報取り扱いご利用時の注意点の同意 </input-label>
          </el-col>
          <el-col :span="6">
            <el-form-item prop="personal_agree" class="personal_agree">
              <jr-checkbox v-model="form.personal_agree" :isEdit="isInputMode">同意する</jr-checkbox>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <el-row>
        <el-col class="pt-5 align-right">
          <span v-if="isConfirmMode">※送信ボタンを押す前に必要により、申請画面を印刷して下さい。</span>
        </el-col>
      </el-row>
      <!-- 戻る・次へボタン -->
      <el-row style="padding: 10px">
        <el-col :span="6">
          <boundary-prev v-model="step" v-if="isConfirmMode" />
        </el-col>
        <el-col :span="6" :offset="12" class="align-right">
          <boundary-next
            v-model="step"
            :boundary="form"
            :formRef="formRef"
            :fileRefs="fileRefs"
            @validationError="validationError = $event"
            @update:boundary="applicantNumber = $event.request_header.applicant_number"
          />
        </el-col>
      </el-row>
    </template>
    <template v-else>
      <input-group title="" style="padding-top: 10px">
        <p>境界立会申請の登録が完了しました</p>
        <p>現地点で受付は完了しておりません。担当者より改めてご連絡いたしますので今しばらくお待ちください。</p>
        <p class="caution-message">※下記の申請番号は、今後のお問い合わせに必要な大切な番号です。必ず控えてください</p>
        <p class="application-number-row">
          申請番号<span id="applicant_number" class="px">{{ applicantNumber }}</span>
        </p>
      </input-group>
    </template>
  </tmp-boundary-login>
</template>

<script lang="ts">
import { defineComponent, reactive, ref, computed, watch } from 'vue'
import { ElForm } from 'element-plus'
import { AxiosResponse } from 'axios'
import { useStore, Store } from '@/store'

import JrBoundaryStep from '@/components/jr-parts/JrBoundaryStep.vue'
import JrRegistConfirmMessage from '@/components/jr-parts/JrRegistConfirmMessage.vue'
import JrGeocoder from '@/components/jr-parts/JrGeocoder.vue'
import JrMap from '@/components/jr-parts/JrMap.vue'
import JrCheckbox from '@/components/jr-parts/JrCheckbox.vue'
import JrNumber from '@/components/jr-parts/JrNumber.vue'
import JrText from '@/components/jr-parts/JrText.vue'
import JrFileInput from '@/components/jr-parts/JrFileInput.vue'
import InputGroup from '@/components/layout/InputGroup.vue'
import InputLabel from '@/components/inputs/InputLabel.vue'
import FormItemDisabled from '@/components/layout/FormItemDisabled.vue'
import LineSelect from '@/components/inputs/LineSelect.vue'
import StationSelect from '@/components/inputs/StationSelect.vue'
import PersonalInfo from '@/components/displays/PersonalInfo.vue'
import TmpBoundaryLogin from '@/components/auth-wrappers/TmpBoundaryLogin.vue'
import RequestReasonTypeSelect from '@/components/inputs/RequestReasonTypeSelect.vue'
import BoundaryNext from '@/components/actions/BoundaryNext.vue'
import BoundaryPrev from '@/components/actions/BoundaryPrev.vue'
import JrInputView from '@/components/jr-parts/JrInputView.vue'

import { DEFAULT_CENTER_LAT, DEFAULT_CENTER_LNG, DEFAULT_ZOOM, PIN_ZOOM } from '@/constants/map'
import { Geocoder } from '@/services/googleMap'
import { addMessageQueue, MESSAGE_TYPE_ERROR } from '@/plugins/messageQueue'
import MessageService from '@/services/message'
import { boundaryRule } from '@/constants/rules'
import { BoundarySteps } from '@/constants/enums'
import { BoundaryForm } from '@/types/forms'
import { FileTypes, RequestReasonTypes, APPLICANT_UPLOAD_FILE_EXTS } from '@/constants/enums'
import { TmpBoundaryGet } from '@/api'
import { ApplicantReadRequest } from '@/requests/tmpBoundary'

/**
 * 画面をスクロールする
 */
const scrollTop = () => {
  window.scrollTo({
    top: 0,
  })
}
/**
 * 境界立会申請 本登録画面
 */
export default defineComponent({
  name: 'Boundary',
  components: {
    JrRegistConfirmMessage,
    InputGroup,
    InputLabel,
    JrText,
    JrCheckbox,
    LineSelect,
    StationSelect,
    FormItemDisabled,
    JrFileInput,
    PersonalInfo,
    TmpBoundaryLogin,
    RequestReasonTypeSelect,
    JrBoundaryStep,
    JrNumber,
    JrGeocoder,
    JrMap,
    BoundaryNext,
    BoundaryPrev,
    JrInputView,
  },
  setup() {
    const step = ref<number>(BoundarySteps.INPUT)
    // 表示している仮申請ID
    const viewTmpBoundaryId = ref<number | null>(null)
    const applicantNumber = ref<string | null>(null)
    const store = useStore() as Store

    const mapCenterLat = ref<string>(DEFAULT_CENTER_LAT)
    const mapCenterLng = ref<string>(DEFAULT_CENTER_LNG)
    const mapZoom = ref<number>(DEFAULT_ZOOM)
    const changeMapCenter = () => {
      mapZoom.value = PIN_ZOOM
      // 中心座標変更時は工事場所住所をリセットする
      form.latitude = ''
      form.longitude = ''
    }
    const form = reactive<BoundaryForm>({
      request_header: {
        applicant_email: '',
        applicant_manager_name: '',
        applicant_address: '',
        applicant_tel: '',
      },
      agent_address: '',
      agent_corporate_name: '',
      agent_name: '',
      contact_tel: '',

      request_reason_type: -1,
      request_reason_type_other: '',
      is_boundary_marker_confirm: false,
      is_boundary_marker_restore: false,
      is_boundary_fixed_surveying: false,

      location: '',
      parcel_number: '',
      land_category: '',
      parcel_area: '',
      line: null,
      line_name: '',
      start_station: null,
      end_station: null,
      start_station_name: '',
      end_station_name: '',
      latitude: '',
      longitude: '',

      jr_site_location: '',
      jr_site_parcel_number: '',
      boundary_application_form_file: -1,
      identification_file: -1,
      power_of_attorney_file: -1,
      location_map_file: -1,
      ground_plan_file: -1,
      survey_drawing_of_acreage_file: -1,
      cadastral_map_file: -1,
      certificate_of_registered_matters_file: -1,
      actual_place_photo_file: -1,
      personal_agree: false,
      boundary_application_form_file_selected: false,
      identification_file_selected: false,
      power_of_attorney_file_selected: false,
      location_map_file_selected: false,
      ground_plan_file_selected: false,
      survey_drawing_of_acreage_file_selected: false,
      cadastral_map_file_selected: false,
      certificate_of_registered_matters_file_selected: false,
      actual_place_photo_file_selected: false,
      work_content_count: 0,
    })

    const validationError = ref<{ start_station?: string; end_station?: string }>({})

    // 仮申請IDが取れ次第、情報を取得する
    watch(
      () => store.getters['tmpBoundary/getId'],
      async (tmpBoundaryId: number | null) => {
        if (tmpBoundaryId == null || viewTmpBoundaryId.value != null) {
          // id無し(未ログイン)か既に取得済みの場合は何もしない
          return
        }
        const request = new ApplicantReadRequest(tmpBoundaryId)
        await request.exec()
        if (request.success) {
          const { data } = request.getResponse() as AxiosResponse<TmpBoundaryGet>

          // 取得した情報をformに入れる
          Object.assign(form, data)
          // メールアドレスを移し替え
          form.request_header.applicant_email = data.applicant_email
          viewTmpBoundaryId.value = tmpBoundaryId
          // 所在からmapの初期位置を検索
          const geocoder = new Geocoder()
          const result = await geocoder.search(form.location)
          if (result === null) {
            addMessageQueue(MESSAGE_TYPE_ERROR, MessageService.codes.GEOCODER_ADDRESS_NOT_FOUND)
          } else {
            mapZoom.value = PIN_ZOOM
            mapCenterLat.value = result.lat.toPrecision(9)
            mapCenterLng.value = result.lng.toPrecision(9)
          }
        }
      },
      { immediate: true }
    )

    // 開始駅・終了駅の監視
    watch(
      () => [form.start_station, form.end_station],
      () => {
        if ((form.start_station == null) === (form.end_station == null)) {
          // どちらも入力されたか、どちらも入力されていない場合エラーをクリアする
          validationError.value = {}
        }
      },
      { deep: true }
    )
    // 作業内容選択数の監視
    watch(
      () => [form.is_boundary_marker_confirm, form.is_boundary_marker_restore, form.is_boundary_fixed_surveying],
      (workContents) => {
        // trueの合計を調べる
        form.work_content_count = workContents.filter((content) => content).length
      },
      { deep: true }
    )

    // step変更時はページ先頭にスクロールする
    watch(step, () => {
      scrollTop()
    })

    // ref群
    const formRef = ref<InstanceType<typeof ElForm>>()
    const boundary_application_form_file_ref = ref<InstanceType<typeof JrFileInput>>()
    const identification_file_ref = ref<InstanceType<typeof JrFileInput>>()
    const power_of_attorney_file_ref = ref<InstanceType<typeof JrFileInput>>()
    const location_map_file_ref = ref<InstanceType<typeof JrFileInput>>()
    const ground_plan_file_ref = ref<InstanceType<typeof JrFileInput>>()
    const survey_drawing_of_acreage_file_ref = ref<InstanceType<typeof JrFileInput>>()
    const cadastral_map_file_ref = ref<InstanceType<typeof JrFileInput>>()
    const certificate_of_registered_matters_file_ref = ref<InstanceType<typeof JrFileInput>>()
    const actual_place_photo_file_ref = ref<InstanceType<typeof JrFileInput>>()
    const fileRefs = [
      boundary_application_form_file_ref,
      identification_file_ref,
      power_of_attorney_file_ref,
      location_map_file_ref,
      ground_plan_file_ref,
      survey_drawing_of_acreage_file_ref,
      cadastral_map_file_ref,
      certificate_of_registered_matters_file_ref,
      actual_place_photo_file_ref,
    ]
    // 入力画面かどうか
    const isInputMode = computed(() => {
      return step.value === BoundarySteps.INPUT
    })
    // 確認画面かどうか
    const isConfirmMode = computed(() => {
      return step.value === BoundarySteps.CONFIRM
    })

    return {
      step,
      form,
      applicantNumber,
      formRef,
      rules: boundaryRule,
      fileRefs,
      isInputMode,
      isConfirmMode,
      validationError,
      RequestReasonTypes,
      FileTypes,
      allowExts: APPLICANT_UPLOAD_FILE_EXTS,
      mapCenterLat,
      mapCenterLng,
      mapZoom,
      changeMapCenter,
      boundary_application_form_file_ref,
      identification_file_ref,
      power_of_attorney_file_ref,
      location_map_file_ref,
      ground_plan_file_ref,
      survey_drawing_of_acreage_file_ref,
      cadastral_map_file_ref,
      certificate_of_registered_matters_file_ref,
      actual_place_photo_file_ref,
      sumpleSubmissionsUrl: process.env.VUE_APP_BOUNDARY_SUMPLE_SUBMISSIONS_URL,
    }
  },
})
</script>

<style scoped>
.application-number-row {
  font-size: xx-large;
  font-weight: 900;
}

.identification-file-label {
  line-height: 20px;
  padding-left: 5px;
}
</style>
